import _ from "lodash";
import {PRODUCT_DETAIL_KEY} from "../constants/pod.constant";

export {
    preparePrintfulParentProductsForAddOrUpdate,
    preparePrintfulProductTypeAndCategories
};

const preparePrintfulParentProductsForAddOrUpdate = (printfulParentProducts, existingParentProductsList, printfulCategoriesInfo, printfulLayoutTemplates, podDetail) => {
    const processedParentProducts = {
        add: [],
        update: []
    };

    const printfulParentProductsList = _.map(printfulParentProducts, (printfulParentProduct, index) => {
        printfulParentProduct.name = printfulParentProduct.title;

        if (printfulParentProduct.title.indexOf('®') > -1) {
            printfulParentProduct.name = printfulParentProduct.title.replace(/®/g, '');
        }

        return printfulParentProduct;
    });

    const printfulCategoriesInfoMap = _.keyBy(printfulCategoriesInfo.categories, 'id');
    const printfulLayoutTemplatesMap = _.keyBy(printfulLayoutTemplates, 'product_id');
    const printfulParentProductsMap = _.keyBy(printfulParentProductsList, PRODUCT_DETAIL_KEY.NAME);
    const notAvailableParentProducts = [];
    // console.log('printfulParentProductsMap', printfulParentProductsMap);
    // console.log('printfulCategoriesInfoMap', printfulCategoriesInfoMap);

    _.forEach(existingParentProductsList, (existingParentProduct, index) => {
        const latestParentProduct = printfulParentProductsMap[existingParentProduct[PRODUCT_DETAIL_KEY.NAME]];
        if (_.isEmpty(latestParentProduct)) {
            // console.log('Not Available - existingParentProduct', existingParentProduct[PRODUCT_DETAIL_KEY.NAME]);
            existingParentProduct.notAvailable = true;
            notAvailableParentProducts.push(existingParentProduct);
        }
    });

    const existingParentProductsMap = _.keyBy(existingParentProductsList, PRODUCT_DETAIL_KEY.NAME);
    // console.log('existingParentProductsMap', existingParentProductsMap);

    _.forEach(printfulParentProductsList, (printfulParentProduct, index) => {
        printfulParentProduct.product_id = printfulParentProduct.id;
        delete printfulParentProduct.id;
        const existingParentProduct = existingParentProductsMap[printfulParentProduct[PRODUCT_DETAIL_KEY.NAME]];

        const category = printfulCategoriesInfoMap[printfulParentProduct.main_category_id];

        if (!_.isEmpty(category)) {
            /*printfulParentProduct.category = category.title;
            printfulParentProduct.parentCategory = category.parent;*/
            printfulParentProduct.category = convertToStartCase(category.title);
            printfulParentProduct.parentCategory = convertToStartCase(category.parent);
        }

        processColorSizeAndOtherDetails(printfulParentProduct, podDetail, printfulLayoutTemplatesMap[printfulParentProduct.product_id]);

        if (_.isEmpty(existingParentProduct)) {
            processedParentProducts.add.push(printfulParentProduct);
            // console.log('*** NEW printfulParentProduct', printfulParentProduct[PRODUCT_DETAIL_KEY.NAME]);
        } else {
            // console.log('*** EXISTING printfulParentProduct', printfulParentProduct[PRODUCT_DETAIL_KEY.NAME]);
            const updateNeeded = prepareExistingParentProductForUpdate(existingParentProduct, printfulParentProduct);

            if (updateNeeded) {
                processedParentProducts.update.push(existingParentProduct);
            }
        }
    });

    processedParentProducts.update = processedParentProducts.update.concat(notAvailableParentProducts);

    console.log('Not Available Parent Products Length -> : ', notAvailableParentProducts.length);
    console.log('Add Parent Products Length -> : ', processedParentProducts.add.length);
    console.log('Update Parent Products Length -> : ', processedParentProducts.update.length);

    /*console.log('Add Parent Products -> : ', processedParentProducts.add);
    console.log('Update Parent Products -> : ', processedParentProducts.update);*/

    return processedParentProducts;
}

const prepareExistingParentProductForUpdate = (existingParentProduct, latestParentProduct) => {
    let updateNeeded = false;
    latestParentProduct.id = existingParentProduct.id;

    _.forIn(latestParentProduct, (value, attribute) => {
        if (attribute !== 'id') {
            // existingParentProduct[attribute] = value;
            if (existingParentProduct.hasOwnProperty(attribute)) {
                if (_.isArray(existingParentProduct[attribute])) {
                    const attributeName = getAttributeName(existingParentProduct[attribute]);

                    const existingListMap = _.keyBy(existingParentProduct[attribute], attributeName);
                    const latestListMap = _.keyBy(value, attributeName);
                    const mergedListMap = _.merge(latestListMap, existingListMap);
                    const mergedList = _.values(mergedListMap);

                    /*console.log(latestParentProduct[attributeName], {
                        value,
                        existingListMap,
                        latestListMap,
                        mergedListMap,
                        mergedList
                    });*/

                    existingParentProduct[attribute] = mergedList;
                    updateNeeded = true;
                } else if (existingParentProduct[attribute] !== value) {
                    existingParentProduct[attribute] = value;
                    updateNeeded = true;
                    // console.log('UPDATE: ', attribute, ' - ', value);
                }
            } else {
                existingParentProduct[attribute] = value;
                updateNeeded = true;
            }
        }
    });

    return updateNeeded;
}

const getAttributeName = (itemsList) => {
    let attributeName = 'name';
    const firstItem = itemsList[0] || {};

    if (firstItem?.hasOwnProperty('key')) {
        attributeName = 'key';
    } else if (firstItem?.hasOwnProperty('id')) {
        attributeName = 'id';
    } else if (firstItem?.hasOwnProperty('title')) {
        attributeName = 'title';
    }

    return attributeName;
}

const convertToStartCase = (text) => {
    // Split the text into individual words
    let words = text.split(' ');
    // let words = text.split(/\s|-/);

    // Iterate over each word and capitalize the first letter
    let result = words.map(function (word) {
        if (word.length > 0) {
            if (word.indexOf('-') > -1) {
                let subWords = word.split('-');
                let subResult = subWords.map(function (subWord) {
                    // Capitalize the first letter of the word
                    let firstLetter = subWord.charAt(0).toUpperCase();
                    let restOfWord = subWord.slice(1).toLowerCase();
                    return firstLetter + restOfWord;
                });

                return subResult.join('-');
            } else {
                // Capitalize the first letter of the word
                let firstLetter = word.charAt(0).toUpperCase();
                let restOfWord = word.slice(1).toLowerCase();
                return firstLetter + restOfWord;
            }
        }
        return word;
    });

// Join the words back together with spaces
    return result.join(' ');
}

const processColorSizeAndOtherDetails = (printfulParentProduct, podDetail, printfulLayoutTemplate) => {
    const colors = {};
    const sizes = {};

    _.forEach(printfulParentProduct.variants, (variant, index) => {
        if (variant.color) {
            if (!colors[variant.color]) {
                colors[variant.color] = {
                    name: variant.color,
                    code: variant.color_code || '',
                    total: 1
                };
            } else {
                colors[variant.color].total = colors[variant.color].total + 1;
            }
        }

        if (variant.size) {
            if (!sizes[variant.size]) {
                sizes[variant.size] = {
                    name: variant.size,
                    total: 1
                };
            } else {
                sizes[variant.size].total = sizes[variant.size].total + 1;
            }
        }
    });

    printfulParentProduct.colors = _.values(colors);
    printfulParentProduct.sizes = _.values(sizes);
    printfulParentProduct.totalColors = _.size(colors);
    printfulParentProduct.totalSizes = _.size(sizes);
    printfulParentProduct.total = _.size(printfulParentProduct.variants);

    printfulParentProduct.type = convertToStartCase(printfulParentProduct.type);
    printfulParentProduct.productType = printfulParentProduct.type;

    printfulParentProduct.key = printfulParentProduct.type + '|' + printfulParentProduct.category + '|' + printfulParentProduct.name;

    printfulParentProduct.market = podDetail.market;
    printfulParentProduct.podId = podDetail.id;

    printfulParentProduct.layout = printfulLayoutTemplate || {};
}

const preparePrintfulProductTypeAndCategories = (processedParentProducts, podDetail) => {
    const productTypes = [];
    const allProductDetail = {colors: []};

    const processedProductsList = processedParentProducts.add.concat(processedParentProducts.update);
    const productTypesMap = _.groupBy(processedProductsList, PRODUCT_DETAIL_KEY.PRODUCT_TYPE);

    _.forEach(productTypesMap, (productTypeParentProductList, productTypeName) => {
        if (productTypeParentProductList && !_.isEmpty(productTypeName) && productTypeName !== 'undefined') {
            const productType: any = {name: productTypeName, totalParentProducts: productTypeParentProductList.length};
            productType.label = productType.name;

            const notAvailableParentProducts = _.filter(productTypeParentProductList, parentProduct => {
                return parentProduct.notAvailable;
            });

            if (notAvailableParentProducts.length > 0) {
                productType.label = productType.name + ' (' + notAvailableParentProducts.length + '/' + productTypeParentProductList.length + ' N/A)';
                productType.totalNotAvailable = notAvailableParentProducts.length;
            }

            prepareCategories(productTypeParentProductList, productType, allProductDetail);

            productTypes.push(productType);
        }
    });

    const allColors = _.map(_.compact(_.uniq(allProductDetail.colors)), colorName => {
        return {
            name: colorName,
            isSingle: colorName.indexOf('/') === -1
        }
    });

    podDetail.productTypesList = _.orderBy(productTypes, 'name');
    podDetail.colors = _.orderBy(allColors, 'name');
}

const prepareCategories = (productTypeParentProductList, productType, allProductDetail) => {
    const categoriesMap = _.groupBy(productTypeParentProductList, PRODUCT_DETAIL_KEY.CATEGORY);
    const categories = [];

    _.forEach(categoriesMap, (categoryParentProductList, categoryName) => {
        const category: any = {name: categoryName};
        prepareColors(categoryParentProductList, category);
        prepareSizes(categoryParentProductList, category);
        prepareParentProducts(categoryParentProductList, category);

        categories.push(category);
        allProductDetail.colors = _.concat(allProductDetail.colors, _.map(category.colors, 'name'));
    });

    productType.categories = _.orderBy(categories, 'name');
}

const prepareColors = (categoryParentProductList, parent) => {
    let colors = [];

    _.forEach(categoryParentProductList, parentProduct => {
        colors = _.concat(colors, parentProduct.colors);
    });

    parent.colors = _.orderBy(colors, 'name');
    parent.totalColors = colors.length;
}

const prepareSizes = (categoryParentProductList, parent) => {
    let sizes = [];

    _.forEach(categoryParentProductList, parentProduct => {
        sizes = _.concat(sizes, parentProduct.sizes);
    });

    parent.sizes = _.orderBy(sizes, 'name');
    parent.totalSizes = sizes.length;
}

const prepareParentProducts = (categoryParentProductList, category) => {
    const parentProducts = [];

    _.forEach(categoryParentProductList, parentProduct => {
        const parent: any = {
            product_id: parentProduct.product_id,
            name: parentProduct.name,
            sizes: _.orderBy(parentProduct?.sizes, 'name'),
            colors: _.orderBy(parentProduct?.colors, 'name'),
            total: parentProduct.total,
            totalColors: parentProduct.totalColors,
            totalSizes: parentProduct.totalSizes,
        };

        parentProducts.push(parent);
    });

    category.parentProducts = _.orderBy(parentProducts, 'name');
    category.totalParentProducts = parentProducts.length;
}
